// extracted by mini-css-extract-plugin
module.exports =  {"alert":"plqg6IEMLKsA1e07z8Xh"};